import React, { useState, useRef, useEffect, use } from 'react';
import { Canvas, useThree } from '@react-three/fiber';
import Experience from './Experience';
import { GUI } from 'dat.gui';
import { OrbitControls } from '@react-three/drei';


const ThreeDmodalRender = ({ Link }) => {
    const [modelUrl, setModelUrl] = useState(null);
    const [zoomLevel, setZoomLevel] = useState(100);
    const [cameraSettings, setCameraSettings] = useState({
        zoom: 55,
        positionX: 3,
        positionY: 1.5,
        positionZ: 1,
    });
    const [orbitControlsSettings, setOrbitControlsSettings] = useState({
        autoRotate: true,
        minDistance: 5,
        maxDistance: 40,
        autoRotateSpeed: 0.5,
        enableDamping: true,
        minPolarAngle: Math.PI / 6,
        maxPolarAngle: Math.PI / 2.5,
    });
    const gui = useRef(null);
    /**
     * Sizes
     */
    useEffect(() => {

        // fetch('/api/scene-data')
        // .then(response => response.json())
        // .then(data => {
        //     setCameraSettings(data.cameraSettings);
        //     setModelUrl(data.modelUrl);
        // })
        // .catch(error => console.error('Error fetching data:', error));
        gui.current = new GUI();
        const cameraFolder = gui.current.addFolder('Camera');

        cameraFolder.add(cameraSettings, 'zoom', 10, 100).onChange((value) => {
            setCameraSettings((prev) => ({ ...prev, zoom: value }));
        });
        cameraFolder.add(cameraSettings, 'positionX', -10, 10).onChange((value) => {
            setCameraSettings((prev) => ({ ...prev, positionX: value }));
        });
        cameraFolder.add(cameraSettings, 'positionY', 1, 3).onChange((value) => {
            setCameraSettings((prev) => ({ ...prev, positionY: value }));
        });
        cameraFolder.add(cameraSettings, 'positionZ', -10, 10).onChange((value) => {
            setCameraSettings((prev) => ({ ...prev, positionZ: value }));
        });

        const orbitControlsFolder = gui.current.addFolder('OrbitControls');

        orbitControlsFolder.add(orbitControlsSettings, 'autoRotate').onChange((value) => {
            setOrbitControlsSettings((prev) => ({ ...prev, autoRotate: value }));
        });
        orbitControlsFolder.add(orbitControlsSettings, 'minDistance', 1, 100).onChange((value) => {
            setOrbitControlsSettings((prev) => ({ ...prev, minDistance: value }));
        });
        orbitControlsFolder.add(orbitControlsSettings, 'maxDistance', 1, 100).onChange((value) => {
            setOrbitControlsSettings((prev) => ({ ...prev, maxDistance: value }));
        });
        orbitControlsFolder.add(orbitControlsSettings, 'autoRotateSpeed', 0.1, 10).onChange((value) => {
            setOrbitControlsSettings((prev) => ({ ...prev, autoRotateSpeed: value }));
        });
        orbitControlsFolder.add(orbitControlsSettings, 'enableDamping').onChange((value) => {
            setOrbitControlsSettings((prev) => ({ ...prev, enableDamping: value }));
        });
        orbitControlsFolder.add(orbitControlsSettings, 'minPolarAngle', 0, Math.PI).onChange((value) => {
            setOrbitControlsSettings((prev) => ({ ...prev, minPolarAngle: value }));
        });
        orbitControlsFolder.add(orbitControlsSettings, 'maxPolarAngle', 0, Math.PI).onChange((value) => {
            setOrbitControlsSettings((prev) => ({ ...prev, maxPolarAngle: value }));
        });

        cameraFolder.open();
        orbitControlsFolder.open();
        return () => {
            gui.current.destroy();
        };
    }, []);
    const sizes = {
        width: (window.innerWidth - 20),
        height: window.innerHeight
    }
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            setModelUrl(url);
        }
    };
    // function CustomCamera() {
    //     const { camera, gl } = useThree();

    //     useEffect(() => {
    //         camera.fov = cameraSettings.zoom;
    //         camera.position.set(
    //             cameraSettings.positionX,
    //             cameraSettings.positionY,
    //             cameraSettings.positionZ
    //         );
    //         camera.lookAt(0, 0, 0);
    //         camera.updateProjectionMatrix();
    //     }, [cameraSettings, camera]);

    //     // Custom camera settings
    //     camera.near = 0.1;
    //     camera.far = 100;

    //     return (
    //         <OrbitControls
    //         enablePan={false}
    //         autoRotate={true}
    //         minDistance={5}
    //         maxDistance={40}
    //         autoRotateSpeed={0.5}
    //         enableDamping={true}
    //         args={[camera, gl.domElement]}
    //         minPolarAngle={Math.PI / 6} // 30 degrees
    //         maxPolarAngle={Math.PI / 2.5} // 90 degrees
    //         />
    //     );
    // }
    useEffect(() => {
        const handleWheel = (event) => {
            event.preventDefault(); // Now this will work
            setOrbitControlsSettings((prev) => {
                let newMinDistance = prev.minDistance + event.deltaY * 0.01;
                let newMaxDistance = prev.maxDistance + event.deltaY * 0.01;

                // Ensure distances stay within reasonable bounds
                newMinDistance = Math.max(1, Math.min(newMinDistance, 100));
                newMaxDistance = Math.max(1, Math.min(newMaxDistance, 100));

                return {
                    ...prev,
                    minDistance: newMinDistance,
                    maxDistance: newMaxDistance,
                };
            });
        };

        window.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            window.removeEventListener('wheel', handleWheel);
        };
    }, []);

    function CustomCamera() {
        const { camera, gl } = useThree();

        useEffect(() => {
            // Set up the orthographic camera properties
            const aspect = window.innerWidth / window.innerHeight;
            camera.left = -cameraSettings.zoom * aspect / 2;
            camera.right = cameraSettings.zoom * aspect / 2;
            camera.top = cameraSettings.zoom / 2;
            camera.bottom = -cameraSettings.zoom / 4;
            camera.position.set(
                cameraSettings.positionX,
                cameraSettings.positionY,
                cameraSettings.positionZ
            );
            camera.lookAt(0, 0, 0);
            camera.updateProjectionMatrix();
        }, [cameraSettings, camera]);

        camera.near = 0.1;
        camera.far = 100;

        return (
            <OrbitControls
                enablePan={false}
                autoRotate={orbitControlsSettings.autoRotate}
                minDistance={orbitControlsSettings.minDistance}
                maxDistance={orbitControlsSettings.maxDistance}
                autoRotateSpeed={orbitControlsSettings.autoRotateSpeed}
                enableDamping={orbitControlsSettings.enableDamping}
                args={[camera, gl.domElement]}
                minPolarAngle={orbitControlsSettings.minPolarAngle}
                maxPolarAngle={orbitControlsSettings.maxPolarAngle}
            />
        );
    }

    const handleAddCategory = () => {
        const dataToSave = {
            cameraSettings: cameraSettings,
            modelUrl: modelUrl,
            orbitControlsSettings: orbitControlsSettings
        };

        const json = JSON.stringify(dataToSave, null, 2);
        console.log('Saved JSON:', json);

        // Here you can add code to save `json` to a backend or local storage
        // Example: Sending data to a backend endpoint
        // fetch('/api/save-scene', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: json
        // }).then(response => response.json())
        //   .then(data => console.log('Saved data:', data))
        //   .catch(error => console.error('Error saving data:', error));
    };
    // function CustomCamera() {
    //     const { camera } = useThree();

    //     // Custom camera settings
    //     camera.fov = 30;
    //     camera.near = 0.1;
    //     camera.far = 100;
    //     camera.position.set(3, 1.5, 1);
    //     camera.lookAt(1, 1, 1);

    //     return null;
    //   }

    useEffect(() => {
        if (Link) {
            setTimeout(() => {
                setModelUrl(Link);
            }, 300);
        }
    }, [Link])


    return (
        <div className='app' style={{ position: 'relative' }}>
            <Canvas
                shadows
            >
                <CustomCamera />
                {
                    modelUrl &&
                    <Experience modelUrl={modelUrl} />

                }
            </Canvas>
        </div>
    );
}

export default ThreeDmodalRender;
